import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportData from 'highcharts/modules/export-data';
import Accessibility from 'highcharts/modules/accessibility';
import HighchartsReact from 'highcharts-react-official';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { isValid } from 'date-fns'

Exporting(Highcharts)
ExportData(Highcharts)
Accessibility(Highcharts)

const AccumPetDptGrf = (props) => { 
    const { smallScreen } = props;
    const [ selectedStartDate, setSelectedStartDate ] = useState();
    const [ maxDate, setMaxDate ] = useState();
    const [ minDate, setMinDate ] = useState();

    const dataFileName = (window.location.hostname === "localhost" ? "." : "/ma") + "/data/station_pet_daily.json";

    const today = new Date();
		const mon = today.getMonth() + 1;
	  const petgrfOn = mon >= 4 && mon <= 11;

    // options for Highcharts plot
    const default_options = {
      chart: {
        zoomType: "x",
        height: Math.min((window.innerHeight * 0.75), 780),
        width: window.innerWidth - (smallScreen ? 0 : 200) - 32,
      },
      colors: [
				'#7cb5ec',
				'#434348',
				'#90ed7d',
				'#f7a35c',
				'#8085e9',
				'#f15c80',
				'#e4d354',
				'#2b908f',
				'#f45b5b',
				'#91e8e1'
			],
      plotOptions: {
        line: {
            cursor: "pointer",
            lineWidth: 2,
            states: {
                hover: {
                    enabled: false
                }
            },
            marker: {
                enabled: false,
                symbol: "diamond",
                fillColor: "black",
                radius: 3
            }
        },
        series: {
          pointPlacement:"on"
        }
      },
      xAxis: {
        type: "datetime",
        dateTimeLabelFormats: {
            day: "%b %e",
            week: "%b %e",
            month: "%b",
            year: "%b"
        },
        gridLineWidth: 1,
      },
      yAxis: {
        title: {
            text: "Accumulated Departure (inches)"
        },
        plotLines: [{
            width: 2,
            value: 0
        }],
      },
      legend: {
        alignColumns: false,
      },
      exporting: {
        menuItemDefinitions: {
          // Custom definition
          downloadCSV: {
            text: 'Download data as CSV'
          },
        },
        buttons: {
          contextButton: {
            menuItems: [
               "downloadPNG",
               "downloadCSV",
             ]
          }
        }
      },
      credits: {
        href: "https://www.rcc-acis.org",
        text: "Powered by ACIS"
      },
      tooltip: {
        shared: true,
        dateTimeLabelFormats: {
            month: "%A, %b %e, %Y",
            day: "%A, %b %e, %Y",
            hour: "%A, %b %e, %Y",
            minute: "%A, %b %e, %Y",
            second: "%A, %b %e, %Y",
            millisecond: "%A, %b %e, %Y",
        },
      },
      title: {
        text: "Accumulated Potential Evapotranspiration Departure from Average (inches)",
      },
      subtitle: {
        text: null,    //added in fill_graph
      },
      series: null,    //added in fill_graph
    };

    const [ options, setOptions ] = useState(default_options);

    function fill_graph(dpt_data) {
      var resVal, dateVal, data_series, accum, ymd,
          needSubtitle = false,
          all_data_series = [];
      // for each station
      Object.entries(dpt_data).forEach(([stn, stndata]) => {
        data_series = [];
        accum = 0.00;
        stndata.forEach((res) => {
            ymd = res[0].split("-");
            dateVal = new Date(parseInt(ymd[0]), parseInt(ymd[1])-1, parseInt(ymd[2]), 0, 0);
            if (dateVal >= selectedStartDate) {
                if (res[1] === "M") {
                    data_series.push({x: dateVal.getTime(), y: accum, marker: {enabled: true}});
                    needSubtitle = true;
                } else {
                    resVal = parseFloat(res[1]);
                    accum += resVal;
                    data_series.push([dateVal.getTime(), accum]);
                }
            }
        });

        if (data_series.length > 0) {
          all_data_series.push({
            name: stn,
            data: data_series,
            type: "line",
            tooltip: {
              valueDecimals: 2,
              valueSuffix: " inches"
            }
          });
        }
      });
      // trigger drawing of graph
	   setOptions({...options, series: all_data_series, subtitle: {text: needSubtitle ? "Black diamonds represent missing values" : ""}});
	};

    const fetchData = () => {
        axios.get(dataFileName)
            .then(results => {
                fill_graph(results.data);
            })
            .catch(err => {
                console.log(err.message);
            });
    };

    useEffect(() => {
      const maxDate = new Date();
      const minDate = new Date(maxDate.getFullYear(),2,1)
      setMinDate(minDate);
      setMaxDate(maxDate);
      setSelectedStartDate(minDate);
    },[] )

    useEffect(() => {
      if (isValid(selectedStartDate) && selectedStartDate >= minDate && selectedStartDate <= maxDate) {
        setOptions({...options, series: null});
        fetchData();
      } else {
        setOptions({...options, series: {}})
      }
      // eslint-disable-next-line
    }, [selectedStartDate]);

    return (
      <>
        {petgrfOn &&
          <>
            {options.series ?
              <>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                />
                <DatePicker 
                  value={selectedStartDate}
                  onChange={setSelectedStartDate}
                  format='yyyy-MM-dd'
                  label="Accumulation start date"
                  minDate={minDate}
                  maxDate={maxDate}
                />
              </>
            :
              <>
                <CircularProgress />
                <span>Loading ...</span>
              </>
            }
          </>
        }
        {!petgrfOn &&
          <Typography tabIndex={0}>
              The accumulated potential evapotranspiration (PET) departure graph is only available for the months of April through November.
          </Typography>
        }
      </>
  )
}

export default AccumPetDptGrf;
